import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchLibrarySongs, fetchLibrarySongsById } from './libraryAPI';
import initialState from './initialState';

export const fetchLibrarySongsAsync = createAsyncThunk(
  'setlist/fetchLibrary',
  async (payload, thunkAPI) => {
    const clientConfig = thunkAPI.getState().ui.clientConfig;
    const response = await fetchLibrarySongs(payload.startIndex, payload.limit, payload.search, payload.activeFilters, clientConfig);
    return response.data;
  }
);

export const fetchLibrarySongsByIdAsync = createAsyncThunk(
  'setlist/fetchLibraryById',
  async (payload, thunkAPI) => {
    const clientConfig = thunkAPI.getState().ui.clientConfig;
    const response = await fetchLibrarySongsById(payload.songIds, clientConfig);
    return response.data;
  }
);


export const librarySlice = createSlice({
  name: 'library',
  initialState,
  reducers: {
    replaceAllLibrarySongs: (state, action) => {
      state.songs = Array.isArray(action.payload) ? action.payload : [];
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLibrarySongsAsync.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchLibrarySongsAsync.rejected, (state, action) => {
        state.status = 'rejected';
        state.songs = [];
      })
      .addCase(fetchLibrarySongsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.songs = action.payload;
      })
      .addCase(fetchLibrarySongsByIdAsync.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchLibrarySongsByIdAsync.rejected, (state, action) => {
        state.status = 'rejected';
        state.songs = [];
      })
      .addCase(fetchLibrarySongsByIdAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.songs = action.payload;
      });
  },
});

// export const { increment, decrement, incrementByAmount } = setlistSlice.actions;

export const { replaceAllLibrarySongs } = librarySlice.actions;

export const selectLibrarySongs = (state) => state.library.songs;
export const selectLibraryStatus = (state) => state.library.status;

export default librarySlice.reducer;
